<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...$$restProps}>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M7.94978 1.9141C7.94978 1.54591 8.24825 1.24744 8.61644 1.24744H14.4449V7.07588C14.4449 7.44407 14.1464 7.74255 13.7782 7.74255C13.41 7.74255 13.1116 7.44407 13.1116 7.07588V3.59467L9.08785 7.61837C8.8275 7.87872 8.40539 7.87872 8.14504 7.61837C7.88469 7.35802 7.88469 6.93591 8.14504 6.67556L12.2398 2.58077H8.61644C8.24825 2.58077 7.94978 2.28229 7.94978 1.9141Z"
		fill="currentColor"
	/>
	<path
		fill-rule="evenodd"
		clip-rule="evenodd"
		d="M4.66667 4.6667C3.93029 4.6667 3.33333 5.26366 3.33333 6.00004V11.3334C3.33333 12.0698 3.93029 12.6667 4.66667 12.6667H10C10.7364 12.6667 11.3333 12.0698 11.3333 11.3334V8.66671C11.3333 8.29852 11.6318 8.00004 12 8.00004C12.3682 8.00004 12.6667 8.29852 12.6667 8.66671V11.3334C12.6667 12.8061 11.4728 14 10 14H4.66667C3.19391 14 2 12.8061 2 11.3334V6.00004C2 4.52728 3.19391 3.33337 4.66667 3.33337H7.33333C7.70152 3.33337 8 3.63185 8 4.00004C8 4.36823 7.70152 4.6667 7.33333 4.6667H4.66667Z"
		fill="currentColor"
	/>
</svg>
